import ChevronIcon from '~/assets/icons/chevron.svg';
import styled, { x } from '@xstyled/styled-components';
import React, { useEffect } from 'react';
import { t } from 'ttag';
import { CloseButton } from '~/ui/buttons/CloseButton';
import { Flex } from '~/ui/flex/Flex';
import { HelpPages, useHelpStore } from './Store';
import { TrainingState, useTrainingStore } from '~/training/state';
import { select } from '~/lib/select';
import { useSequenceStore } from '~/training/sequence/SequenceStore';
import PointOfContact from '~/ui/point-of-contact/PointOfContact';

const Chevron = styled(ChevronIcon)`
  margin-left: 8px;
  stroke: var(--color-black);
`;

const MenuItem = styled.button`
  border: none;
  background: none;
  display: flex;
  height: 48px;
  text-align: left;
  padding: 0;
  align-items: center;
  color: ${p => p.theme.colors.black};
`;

const selector = (s: TrainingState) =>
  select(
    s,
    'featureShowHotline',
    'featureShowAbout',
    'featureShowIssueReporting',
    'feedbackUrl'
  );

export const Root = () => {
  const { page, setPage, toggle, open } = useHelpStore();
  const {
    featureShowHotline,
    featureShowAbout,
    featureShowIssueReporting,
    feedbackUrl
  } = useTrainingStore(selector);

  const { addBlocker, removeBlocker } = useSequenceStore();

  useEffect(() => {
    addBlocker('nextBtn');
    return () => removeBlocker('nextBtn');
  }, [open, page]);

  if (page !== HelpPages.Root) return null;

  return (
    <>
      <CloseButton onClick={() => toggle(false)} />
      <Flex variant="list">
        <x.h2 ml="30px" fontFamily="llama">{t`How can I help?`}</x.h2>
        <MenuItem onClick={() => setPage(HelpPages.FAQ)}>
          <x.span flex="1">{t`Visit the EasyLlama FAQ`}</x.span>
          <Chevron />
        </MenuItem>
        {featureShowHotline && feedbackUrl && (
          <MenuItem
            onClick={() => {
              window.open(feedbackUrl, '_blank');
            }}
          >
            <x.span flex="1">{t`Send anonymous feedback to your organization`}</x.span>
            <Chevron />
          </MenuItem>
        )}
        {featureShowHotline && !feedbackUrl && (
          <MenuItem onClick={() => setPage(HelpPages.ConfidentialHotline)}>
            <x.span flex="1">{t`Ask your organization a question`}</x.span>
            <Chevron />
          </MenuItem>
        )}
        {featureShowIssueReporting && (
          <MenuItem onClick={() => setPage(HelpPages.ReportIssue)}>
            <x.span flex="1">{t`Report an issue with this slide`}</x.span>
            <Chevron />
          </MenuItem>
        )}
        {featureShowAbout && (
          <MenuItem
            onClick={() => {
              window.open('https://www.easyllama.com', '_blank');
            }}
          >
            <x.span flex="1">{t`About EasyLlama`}</x.span>
            <Chevron />
          </MenuItem>
        )}
        <PointOfContact />
      </Flex>
    </>
  );
};
